import { Card, Col, Row, Select } from "antd";
import { useEffect, useState } from "react";
import { TEST_RIDE_SUMMARY } from "../../../Common/Grafana/Constants";
import ChartFilter from "../../../Common/ChartFilter";
import GetIframe from "../../../Common/Grafana/GetIframe";

const GrafanaCompare = ({
  baseUrl,
  baseFilterObject,
  compareCharts,
}) => {
  const [chartType, setChartType] = useState({
    timeSeries: true,
    histogram: false,
    boxPlot: false,
  });

  const [compareValue, setCompareValue] = useState(compareCharts || []);

  useEffect(() => {
    setCompareValue(compareCharts?.length > 0 ? [...compareCharts] : []);
    setChartType({ timeSeries: true, histogram: false, boxPlot: false });
  }, [compareCharts]);

  const updateCompareValue = (index, value) => {
    const newValue = [...compareValue];
    newValue[index] = value;
    setCompareValue([...newValue]);
  };

  const updateChartType = (name, value) => {
    setChartType((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <Row gutter={[16, 16]} className="grafana-compare">
      <Col span={24}>
        <Card
          title={
            <Row gutter={[16, 16]} justify={"space-between"} className="pd05">
              <Col>
                <Row gutter={[16, 16]} align={"middle"}>
                  <Col>
                    <Select
                      placeholder="Select a chart type"
                      value={compareValue?.[0]}
                      style={{ width: "200px" }}
                      onChange={(value) => updateCompareValue(0, value)}
                    >
                      <Select.OptGroup label="Motor">
                        <Select.Option value="speed">Speed</Select.Option>
                        <Select.Option value="MCS">
                          MCS Temperature
                        </Select.Option>
                        <Select.Option value="motor">
                          Motor Temperature
                        </Select.Option>
                      </Select.OptGroup>
                      <Select.OptGroup label="Battery">
                        <Select.Option value="batteryVoltage">
                          Voltage
                        </Select.Option>
                        <Select.Option value="batteryCurrent">
                          Current
                        </Select.Option>
                        <Select.Option value="batterySOC">SOC</Select.Option>
                        <Select.Option value="batterySOH">SOH</Select.Option>
                        <Select.Option value="batteryMinTemp">
                          Min Temperature
                        </Select.Option>
                        <Select.Option value="batteryMaxTemp">
                          Max Temperature
                        </Select.Option>
                      </Select.OptGroup>
                      <Select.OptGroup label="Braking">
                        <Select.Option value="brakeDuration">
                          Duration
                        </Select.Option>
                        <Select.Option value="brakeDistance">
                          Distance
                        </Select.Option>
                        <Select.Option value="brakeIntensity">
                          Intensity
                        </Select.Option>
                      </Select.OptGroup>
                      <Select.Option value="turns">Turns</Select.Option>
                      <Select.Option value="stopsDuration">
                        Stops Duration
                      </Select.Option>
                      {/* <Select.Option value="energyMetrics">
                        Energy Metrics
                      </Select.Option> */}
                      <Select.OptGroup label="Acceleration">
                        <Select.Option value="AccelerationDuration">
                          Duration
                        </Select.Option>
                        <Select.Option value="AccelerationDistance">
                          Distance
                        </Select.Option>
                      </Select.OptGroup>
                      <Select.OptGroup label="Deceleration">
                        <Select.Option value="DecelerationDuration">
                          Duration
                        </Select.Option>
                        <Select.Option value="DecelerationDistance">
                          Distance
                        </Select.Option>
                      </Select.OptGroup>
                    </Select>
                  </Col>

                  <Col>
                    <Select
                      placeholder="Select a chart type"
                      value={compareValue?.[1]}
                      style={{ width: "200px" }}
                      onChange={(value) => updateCompareValue(1, value)}
                    >
                      <Select.OptGroup label="Motor">
                        <Select.Option value="speed">Speed</Select.Option>
                        <Select.Option value="MCS">
                          MCS Temperature
                        </Select.Option>
                        <Select.Option value="motor">
                          Motor Temperature
                        </Select.Option>
                      </Select.OptGroup>
                      <Select.OptGroup label="Battery">
                        <Select.Option value="batteryVoltage">
                          Voltage
                        </Select.Option>
                        <Select.Option value="batteryCurrent">
                          Current
                        </Select.Option>
                        <Select.Option value="batterySOC">SOC</Select.Option>
                        <Select.Option value="batterySOH">SOH</Select.Option>
                        <Select.Option value="batteryMinTemp">
                          Min Temperature
                        </Select.Option>
                        <Select.Option value="batteryMaxTemp">
                          Max Temperature
                        </Select.Option>
                      </Select.OptGroup>
                      <Select.OptGroup label="Braking">
                        <Select.Option value="brakeDuration">
                          Duration
                        </Select.Option>
                        <Select.Option value="brakeDistance">
                          Distance
                        </Select.Option>
                        <Select.Option value="brakeIntensity">
                          Intensity
                        </Select.Option>
                      </Select.OptGroup>
                      <Select.Option value="turns">Turns</Select.Option>
                      <Select.Option value="stopsDuration">
                        Stops Duration
                      </Select.Option>
                      {/* <Select.Option value="energyMetrics">
                        Energy Metrics
                      </Select.Option> */}
                      <Select.OptGroup label="Acceleration">
                        <Select.Option value="AccelerationDuration">
                          Duration
                        </Select.Option>
                        <Select.Option value="AccelerationDistance">
                          Distance
                        </Select.Option>
                      </Select.OptGroup>
                      <Select.OptGroup label="Deceleration">
                        <Select.Option value="DecelerationDuration">
                          Duration
                        </Select.Option>
                        <Select.Option value="DecelerationDistance">
                          Distance
                        </Select.Option>
                      </Select.OptGroup>
                    </Select>
                  </Col>

                  <Col>
                    <Select
                      placeholder="Select a chart type"
                      value={compareValue?.[2]}
                      style={{ width: "200px" }}
                      onChange={(value) => updateCompareValue(2, value)}
                    >
                      <Select.OptGroup label="Motor">
                        <Select.Option value="speed">Speed</Select.Option>
                        <Select.Option value="MCS">
                          MCS Temperature
                        </Select.Option>
                        <Select.Option value="motor">
                          Motor Temperature
                        </Select.Option>
                      </Select.OptGroup>
                      <Select.OptGroup label="Battery">
                        <Select.Option value="batteryVoltage">
                          Voltage
                        </Select.Option>
                        <Select.Option value="batteryCurrent">
                          Current
                        </Select.Option>
                        <Select.Option value="batterySOC">SOC</Select.Option>
                        <Select.Option value="batterySOH">SOH</Select.Option>
                        <Select.Option value="batteryMinTemp">
                          Min Temperature
                        </Select.Option>
                        <Select.Option value="batteryMaxTemp">
                          Max Temperature
                        </Select.Option>
                      </Select.OptGroup>
                      <Select.OptGroup label="Braking">
                        <Select.Option value="brakeDuration">
                          Duration
                        </Select.Option>
                        <Select.Option value="brakeDistance">
                          Distance
                        </Select.Option>
                        <Select.Option value="brakeIntensity">
                          Intensity
                        </Select.Option>
                      </Select.OptGroup>
                      <Select.Option value="turns">Turns</Select.Option>
                      <Select.Option value="stopsDuration">
                        Stops Duration
                      </Select.Option>
                      {/* <Select.Option value="energyMetrics">
                        Energy Metrics
                      </Select.Option> */}
                      <Select.OptGroup label="Acceleration">
                        <Select.Option value="AccelerationDuration">
                          Duration
                        </Select.Option>
                        <Select.Option value="AccelerationDistance">
                          Distance
                        </Select.Option>
                      </Select.OptGroup>
                      <Select.OptGroup label="Deceleration">
                        <Select.Option value="DecelerationDuration">
                          Duration
                        </Select.Option>
                        <Select.Option value="DecelerationDistance">
                          Distance
                        </Select.Option>
                      </Select.OptGroup>
                    </Select>
                  </Col>
                </Row>
              </Col>
              <Col>
                <ChartFilter
                  updateChartType={updateChartType}
                  chartType={chartType}
                />
              </Col>
            </Row>
          }
        >
          {compareValue.map((chart, index) => (
            <Row id={index} key={index} gutter={[16, 16]} className="mt05">
              {chartType?.timeSeries ? (
                <Col xs={24} sm={24} md={24} flex={3} id={`${chart.toLowerCase()+index}-timeSeries`}>
                  <GetIframe
                    title="Battery TimeSeries"
                    url={baseUrl}
                    panelId={TEST_RIDE_SUMMARY.PANEL_ID[chart]["timeSeries"]}
                    variableObject={baseFilterObject}
                    variableKeys={TEST_RIDE_SUMMARY.BASE_VARIABLES}
                    width="100%"
                    height="235"
                    divId={`${chart.toLowerCase()+index}-timeSeries`}
                  />
                </Col>
              ) : null}
              {chartType?.histogram ? (
                <Col
                  xs={24}
                  sm={24}
                  md={24}
                  flex={"auto"}
                  id={`${chart.toLowerCase()+index}-histogram`}
                >
                  <GetIframe
                    title="Battery Histogram"
                    url={baseUrl}
                    panelId={TEST_RIDE_SUMMARY.PANEL_ID[chart].histogram}
                    variableObject={baseFilterObject}
                    variableKeys={TEST_RIDE_SUMMARY.BASE_VARIABLES}
                    width="100%"
                    height="235"
                    divId={`${chart.toLowerCase()+index}-histogram`}
                  />
                </Col>
              ) : null}
              {chartType?.boxPlot ? (
                <Col xs={24} sm={24} md={24} flex={"auto"} id={`${chart.toLowerCase()+index}-boxPlot`}>
                  <GetIframe
                    title="Battery Boxplot"
                    url={baseUrl}
                    panelId={TEST_RIDE_SUMMARY.PANEL_ID[chart].boxPlot}
                    variableObject={baseFilterObject}
                    variableKeys={TEST_RIDE_SUMMARY.BASE_VARIABLES}
                    width="100%"
                    height="235"
                    divId={`${chart.toLowerCase()+index}-boxPlot`}
                  />
                </Col>
              ) : null}
            </Row>
          ))}
        </Card>
      </Col>
    </Row>
  );
};

export default GrafanaCompare;
